import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import PageStandard from "../../components/PageStandard";
import { valueOrDefault } from "../../utils";
import List from "./components/List";
import PropTypes from "prop-types";
import { listUnitsOfMeasure, listUnitsOfMeasureReset } from "../../actions";
import CommodityUnitsOfMeasureEditModal from "./components/Modal";
import { filterUnitsOfMeasureByType } from "../../utils/adapters";

export const WfpManagerCommodityUnitsOfMeasureView = ({
  isFetching,
  errorMessage,
  commodityUnitsOfMeasure,
  page,
  count,
  listUnitsOfMeasure,
  listUnitsOfMeasureReset,
}) => {
  const { t } = useTranslation();
  const [modalOptions, setModalOptions] = useState({isOpen: false, id: undefined, type: undefined});

  // On component mount the data are fetched
  useEffect(() => {
    listUnitsOfMeasure();
    return () => {
      listUnitsOfMeasureReset();
    };
  }, []);

  return (
    <PageStandard title={t("configuration.item.commodityUnitsOfMeasure")}>
      <List
        {...{
          isFetching,
          errorMessage,
          commodityUnitsOfMeasure,
          page,
          count,
          setModalOptions,
        }}
      />
      <CommodityUnitsOfMeasureEditModal
        modalOptions={modalOptions}
        setModalOptions={setModalOptions}
      />
    </PageStandard>
  );
};

WfpManagerCommodityUnitsOfMeasureView.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  commodityUnitsOfMeasure: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  listUnitsOfMeasure: PropTypes.func.isRequired,
  listUnitsOfMeasureReset: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  const data = filterUnitsOfMeasureByType(state, "COMMODITY");

  return {
    commodityUnitsOfMeasure: data,
    isFetching: state.listUnitsOfMeasure.isFetching,
    errorMessage: state.listUnitsOfMeasure.errorMessage,
    page: 1,
    count: valueOrDefault(state.listUnitsOfMeasure.data.results.length, 0),
  };
};

// Maps functions to dispatch actions
export const mapDispatchToProps = (dispatch) => {
  return {
    listUnitsOfMeasure: () => dispatch(listUnitsOfMeasure()),
    listUnitsOfMeasureReset: () => dispatch(listUnitsOfMeasureReset()),
  };
};

// The component uses the redux store
export default connect(mapStateToProps, mapDispatchToProps)(WfpManagerCommodityUnitsOfMeasureView);
